import { instance } from './index';

function xmlList() {
  return instance.get(`api/ingame/xml`);
}

function detailXml(id) {
  return instance.get(`api/ingame/xml/${id}`);
}

//
function createXml(data) {
  return instance.post(`api/ingame/xml/`, data);
}

function updateXml(id, data) {
  return instance.put(`api/ingame/xml/${id}`, data);
}

function deleteXml(id) {
  return instance.delete(`api/ingame/xml/${id}`);
}

export { xmlList, detailXml, createXml, updateXml, deleteXml };
